/*****************************************************************
 *  History Events
 * ***************************************************************/

export const LOADING_ACTION = "LOADING_ACTION"
export const SET_POPUP = "SET_POPUP"
export const CLEAR_POPUP = "CLEAR_POPUP"

export const POPUP_TYPES = {
    CONFIRM_LEAVE_EDIT_MODE: 'confirmLeaveEditMode',
    CONFIRM_DELETE_VERSION: 'confirmDeleteVersion',
    CONFIRM_CANCEL_CHANGES: 'confirmCancelChanges',
    SAVING: 'saving',
    CUSTOM: 'custom'
};
